// extracted by mini-css-extract-plugin
module.exports = {"root":"go-back-module--root--1S8Ni","iconBody":"go-back-module--iconBody--2QhGL"};